import { getMatchingBreakpoint } from '../../breakpoints';
import { createSingletonState } from '../use-singleton-handler';
function getIsMobile() {
    if (typeof window === 'undefined') {
        // assume desktop in server-rendering
        return false;
    }
    return getMatchingBreakpoint(window.innerWidth, ['xs']) !== 'xs';
}
export var useMobile = createSingletonState({
    initialState: function () { return getIsMobile(); },
    factory: function (handler) {
        var listener = function () { return handler(getIsMobile()); };
        window.addEventListener('resize', listener);
        return function () {
            window.removeEventListener('resize', listener);
        };
    }
});
//# sourceMappingURL=index.js.map